export enum VitalsConstants {
  VITALS_ACTION_SAVE = 'vitals/VITALS_ACTION_SAVE',
  SET_PTA = 'vitals/SET_PTA',
  SET_DATE = 'vitals/SET_DATE',
  SET_TIME = 'vitals/SET_TIME',
  SYNC_DATE_TIME = 'vitals/SYNC_DATE_TIME',
  SYNC_PTA = 'vitals/SYNC_PTA',
  ADD_CURRENT_TIME = 'vitals/ADD_CURRENT_TIME',
  SET_ASSESSED_BY = 'vitals/SET_ASSESSED_BY',
  SET_COMMENTS = 'vitals/SET_COMMENTS',
  SET_SYSTOLIC_BLOOD_PRESSURE = 'vitals/SET_SYSTOLIC_BLOOD_PRESSURE',
  SET_SYSTOLIC_BLOOD_PRESSURE_PNNV = 'vitals/SET_SYSTOLIC_BLOOD_PRESSURE_PNNV',
  SET_DIASTOLIC_BLOOD_PRESSURE = 'vitals/SET_DIASTOLIC_BLOOD_PRESSURE',
  SET_DIASTOLIC_BLOOD_PRESSURE_PNNV = 'vitals/SET_DIASTOLIC_BLOOD_PRESSURE_PNNV',
  SET_BLOOD_PRESSURE_METHOD = 'vitals/SET_BLOOD_PRESSURE_METHOD',
  SET_BLOOD_PRESSURE_METHOD_PNNV = 'vitals/SET_BLOOD_PRESSURE_METHOD_PNNV',
  SET_MAP_VITAL = 'vitals/SET_MAP_VITAL',
  SET_HEART_RATE = 'vitals/SET_HEART_RATE',
  SET_HEART_RATE_PNNV = 'vitals/SET_HEART_RATE_PNNV',
  SET_HEART_RATE_METHOD = 'vitals/SET_HEART_RATE_METHOD',
  SET_SPO2 = 'vitals/SET_SPO2',
  SET_SPO2_PNNV = 'vitals/SET_SPO2_PNNV',
  SET_ROOM_AIR = 'vitals/SET_ROOM_AIR',
  SET_RESPIRATION_RATE = 'vitals/SET_RESPIRATION_RATE',
  SET_RESPIRATION_RATE_PNNV = 'vitals/SET_RESPIRATION_RATE_PNNV',
  SET_RESPIRATION_RATE_EFFORT = 'vitals/SET_RESPIRATION_RATE_EFFORT',
  SET_RHYTHM = 'vitals/SET_RHYTHM',
  SET_RHYTHM_PNNV = 'vitals/SET_RHYTHM_PNNV',
  SET_REGULARITY = 'vitals/SET_REGULARITY',
  SET_ECG_TYPE = 'vitals/SET_ECG_TYPE',
  SET_ECG_TYPE_METHOD = 'vitals/SET_ECG_TYPE_METHOD',
  SET_TEMPERATURE = 'vitals/SET_TEMPERATURE',
  SET_TEMPERATURE_PNNV = 'vitals/SET_TEMPERATURE_PNNV',
  SET_TEMPERATURE_TYPE = 'vitals/SET_TEMPERATURE_TYPE',
  SET_ETCO2_TYPE = 'vitals/SET_ETCO2_TYPE',
  SET_TEMPERATURE_METHOD = 'vitals/SET_TEMPERATURE_METHOD',
  SET_SPCO = 'vitals/SET_SPCO',
  SET_SPCO_PNNV = 'vitals/SET_SPCO_PNNV',
  SET_SPMET = 'vitals/SET_SPMET',
  SET_RTS = 'vitals/SET_RTS',
  SET_ETCO2 = 'vitals/SET_ETCO2',
  SET_ETCO2_PNNV = 'vitals/SET_ETCO2_PNNV',
  SET_GLUCOSE = 'vitals/SET_GLUCOSE',
  SET_GLUCOSE_PNNV = 'vitals/SET_GLUCOSE_PNNV',
  SET_GLUCOSE_LEVEL = 'vitals/SET_GLUCOSE_LEVEL',
  SET_LEVEL_OF_CONSCIOUSNESS = 'vitals/SET_LEVEL_OF_CONSCIOUSNESS',
  SET_PAIN = 'vitals/SET_PAIN',
  SET_PAIN_PNNV = 'vitals/SET_PAIN_PNNV',
  SET_PAIN_TYPE = 'vitals/SET_PAIN_TYPE',
  SET_PAIN_QUALITY = 'vitals/SET_PAIN_QUALITY',
  SET_PAIN_QUALITY_ONSET = 'vitals/SET_PAIN_QUALITY_ONSET',
  SET_PAIN_QUALITY_ONSET_UNIT = 'vitals/SET_PAIN_QUALITY_ONSET_UNIT',
  SET_PAIN_QUALITY_FIELD1 = 'vitals/SET_PAIN_QUALITY_FIELD1',
  SET_PAIN_QUALITY_FIELD2 = 'vitals/SET_PAIN_QUALITY_FIELD2',
  SET_PAIN_QUALITY_FIELD3 = 'vitals/SET_PAIN_QUALITY_FIELD3',
  SET_PAIN_QUALITY_FIELD4 = 'vitals/SET_PAIN_QUALITY_FIELD4',
  SET_PAIN_QUALITY_FIELD5 = 'vitals/SET_PAIN_QUALITY_FIELD5',
  SET_PAIN_QUALITY_FIELD6 = 'vitals/SET_PAIN_QUALITY_FIELD6',
  SET_PAIN_QUALITY_FIELD7 = 'vitals/SET_PAIN_QUALITY_FIELD7',
  SET_PAIN_QUALITY_COMMENTS = 'vitals/SET_PAIN_QUALITY_COMMENTS',
  SET_PAIN_SCALES = 'vitals/SET_PAIN_SCALES',
  SET_SEDATION_SCALE = 'vitals/SET_SEDATION_SCALE',
  THROW_VITALS_EXCEPTION = 'vitals/THROW_VITALS_EXCEPTION',
  LOG_RESPONSE = 'vitals/LOG_RESPONSE',
  SET_STROKE_SCALE = 'vitals/SET_STROKE_SCALE',
  SET_STROKE_SCALE_PNNV = 'vitals/SET_STROKE_SCALE_PNNV',
  SET_STROKE_SCALE_SCORE_TOTAL = 'vitals/SET_STROKE_SCALE_SCORE_TOTAL',
  SET_VITALS_STROKE_SCALE_VALUES = 'vitals/SET_VITALS_STROKE_SCALE_VALUES',
  SET_STROKE_SCALE_SCORE_TOTAL_PNNV = 'vitals/SET_STROKE_SCALE_SCORE_TOTAL_PNNV',
  SET_STROKE_SCALE_SCORE_TOTAL_PNNV_ENABLED = 'vitals/SET_STROKE_SCALE_SCORE_TOTAL_PNNV_ENABLED',
  RESET_PATIENT_VITALS_STATE = 'vitals/RESET_PATIENT_VITALS_STATE',
  SET_RESPONSE = 'vitals/SET_RESPONSE',
  SET_STATE = 'vitals/SET_STATE',
  SET_EYE_OPENING_RESPONSE = 'vitals/SET_EYE_OPENING_RESPONSE',
  SET_EYE_OPENING_RESPONSE_PNNV = 'vitals/SET_EYE_OPENING_RESPONSE_PNNV',
  SET_EYE_OPENING_RESPONSE_SCORE = 'vitals/SET_EYE_OPENING_RESPONSE_SCORE',
  SET_VERBAL_RESPONSE_SCORE = 'vitals/SET_VERBAL_RESPONSE_SCORE',
  SET_MOTOR_RESPONSE_SCORE = 'vitals/SET_MOTOR_RESPONSE_SCORE',
  SET_TOTAL_GSC_SCORE = 'vitals/SET_TOTAL_GSC_SCORE',
  SET_TOTAL_GSC_SCORE_PNNV = 'vitals/SET_TOTAL_GSC_SCORE_PNNV',
  SET_VERBAL_RESPONSE = 'vitals/SET_VERBAL_RESPONSE',
  SET_VERBAL_RESPONSE_PNNV = 'vitals/SET_VERBAL_RESPONSE_PNNV',
  SET_MOTOR_RESPONSE = 'vitals/SET_MOTOR_RESPONSE',
  SET_MOTOR_RESPONSE_PNNV = 'vitals/SET_MOTOR_RESPONSE_PNNV',
  SET_PROTOCOL = 'vitals/SET_PROTOCOL',
  SET_STROKE_SCALE_QUESTION_ANSWER = 'vitals/SET_STROKE_SCALE_QUESTION_ANSWER',
  SET_NIH_POSITIVE_STROKE_SCALE_SCORE_MAP = 'vitals/SET_NIH_POSITIVE_STROKE_SCALE_SCORE_MAP',
  SET_RACE_STROKE_SCALE_SCORE_MAP = 'vitals/SET_RACE_STROKE_SCALE_SCORE_MAP',
  ADD_TO_TIMELINE = 'vitals/ADD_TO_TIMELINE',
  SET_LAST_VITALS = 'vitals/SET_LAST_VITALS',
  SET_SHOW_REPEAT_VITALS = 'vitals/SET_SHOW_REPEAT_VITALS',
  SET_SHOW_DATE_TIME_TOAST = 'vitals/SET_SHOW_DATE_TIME_TOAST',
  SET_SHOW_PTA_TOAST = 'vitals/SET_SHOW_PTA_TOAST',
  SET_IS_PAIN_RANGE_ACTIVATED = 'vitals/SET_IS_PAIN_RANGE_ACTIVATED',
  SET_QUALIFIER = 'vitals/SET_QUALIFIER',
  SET_QUALIFIER_PNNV = 'vitals/SET_QUALIFIER_PNNV',
  SET_APGAR_APPEARANCE = 'vitals/SET_APGAR_APPEARANCE',
  SET_APGAR_PULSE = 'vitals/SET_APGAR_PULSE',
  SET_APGAR_GRIMACE = 'vitals/SET_APGAR_GRIMACE',
  SET_APGAR_ACTIVITY = 'vitals/SET_APGAR_ACTIVITY',
  SET_APGAR_RESPIRATION = 'vitals/SET_APGAR_RESPIRATION',
  SET_TOTAL_APGAR_SCORE = 'vitals/SET_TOTAL_APGAR_SCORE',
  SET_TOTAL_APGAR_SCORE_PNNV = 'vitals/SET_TOTAL_APGAR_SCORE_PNNV',
  RESET_APGAR_FIELDS = 'vitals/RESET_APGAR_FIELDS',
  SET_MANUAL_APGAR_TOTAL_CHECKED = 'vitals/SET_MANUAL_APGAR_TOTAL_CHECKED',
  SET_APGAR = 'vitals/SET_APGAR',
  CHECK_QUICK_ACTIONS_REDIRECT = 'vitals/CHECK_QUICK_ACTIONS_REDIRECT',
  SET_IS_REDIRECTED_FROM = 'vitals/SET_IS_REDIRECTED_FROM',
  SET_CUSTOM_VITAL_LABEL1 = 'vitals/SET_CUSTOM_VITAL_LABEL1',
  SET_CUSTOM_VITAL_LABEL2 = 'vitals/SET_CUSTOM_VITAL_LABEL2',
  SET_CUSTOM_VITAL_VALUE1 = 'vitals/SET_CUSTOM_VITAL_VALUE1',
  SET_CUSTOM_VITAL_VALUE2 = 'vitals/SET_CUSTOM_VITAL_VALUE2',
  SET_CUSTOM_VITAL_CONFIG = 'vitals/SET_CUSTOM_VITAL_CONFIG',
  SET_CUSTOM_VITAL_LABEL_EXISTS = 'vitals/SET_CUSTOM_VITAL_LABEL_EXISTS',
  SET_ADD_VITAL = 'vitals/SET_ADD_VITAL',
  SET_SCROLL_TO = 'vitals/SET_SCROLL_TO',
  SET_SHOCK_INDEX = 'vitals/SET_SHOCK_INDEX',
  SET_WITHDRAWAL_SCALES = 'vitals/SET_WITHDRAWAL_SCALES',
  SET_WITHDRAWAL_SCALE_TYPE = 'vitals/SET_WITHDRAWAL_SCALE_TYPE',
  SET_WITHDRAWAL_SCALES_TOTAL = 'vitals/SET_WITHDRAWAL_SCALES_TOTAL',
  SET_WITHDRAWAL_SCALES_TOTAL_PNNV = 'vitals/SET_WITHDRAWAL_SCALES_TOTAL_PNNV',
  SET_WITHDRAWAL_SCALES_TOTAL_PNNV_ENABLED = 'vitals/SET_WITHDRAWAL_SCALES_TOTAL_PNNV_ENABLED',
  SET_WITHDRAWAL_SCALE_TYPE_CLEARED = 'vitals/SET_WITHDRAWAL_SCALE_TYPE_CLEARED',
}

export const CustomVitalConstants = {
  HIDE_CUSTOM_VITALS: 0,
  EDITABLE_LABEL_CUSTOM_VITALS: 1,
  FIXED_LABEL_CUSTOM_VITALS: 2,
} as const
